import('./Render');

(async () => {
	try {
		await caches.delete('TRANSLATION_REQUEST_CACHE');

		await window.navigator.serviceWorker.register('cacheTranslationsWorker.js');
		console.log('Service worker registered.');
	} catch (err) {
		console.warn('Service worker registration failed:', err);
	}
})();
